// src/services/trackingApi.js
import { fetchRoute } from "./ors";

let intervalId = null;
let fullRoute = [];
let currentIndex = 0;

export const startTracking = async (bId, onLocationUpdate) => {
  const urlParams = new URLSearchParams(window.location.search);
  const startStr = urlParams.get("start");
  const endStr = urlParams.get("end");

  if (!startStr || !endStr) return;

  const [slat, slng] = startStr.split(",").map(parseFloat);
  const [elat, elng] = endStr.split(",").map(parseFloat);

  const start = [slat, slng];
  const end = [elat, elng];

  const result = await fetchRoute(start, end);
  fullRoute = result?.geometry ?? [start, end];

  currentIndex = 0;
  intervalId = setInterval(() => {
    if (currentIndex < fullRoute.length) {
      const [lat, lng] = fullRoute[currentIndex];
      onLocationUpdate({ lat, lng, timestamp: Date.now() });
      currentIndex++;
    } else {
      clearInterval(intervalId);
    }
  }, 1500);
};

export const stopTracking = () => {
  if (intervalId) clearInterval(intervalId);
  fullRoute = [];
  currentIndex = 0;
};

export const getCurrentRoute = () => fullRoute;